// extracted by mini-css-extract-plugin
module.exports = {"root":"Button.default_root__vdFkI","isLoading":"Button.default_isLoading__2b4Rl"};